<div class="flag">
  <span [ngStyle]="{'width': size+'px', 'height': size+'px'}" class="flag-icon flag-icon-squared flag-icon-{{countryCode?.toLowerCase()}}"></span>
</div>
